import { render, staticRenderFns } from "./Popover.vue?vue&type=template&id=08bf2e71&scoped=true"
import script from "./Popover.vue?vue&type=script&lang=ts"
export * from "./Popover.vue?vue&type=script&lang=ts"
import style0 from "./Popover.vue?vue&type=style&index=0&id=08bf2e71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bf2e71",
  null
  
)

export default component.exports